import React, {useCallback} from 'react';
import {FormData} from '../DialogHeader';
import {ShownForm} from './ShownForm';
import DraggableList from '../../../../components/Common/DraggableList';
import {formsStore} from '../../../../_legacy/Form/stores/FormsStore';

type Props = {
    data: FormData[];
    toggleChecked: (entityId: string, isChecked: boolean) => void;
    totalSelected: number;
    setShownForms: React.Dispatch<React.SetStateAction<FormData[]>>;
    handleChange: () => void;
};

export const SelectedList = ({
    data,
    toggleChecked,
    totalSelected,
    setShownForms,
    handleChange
}: Props) => {
    const handleReorder = useCallback(
        forms => {
            setShownForms(forms);
            formsStore.currentForm.setCurrentFieldMoreInfo(forms);
            handleChange();
        },
        [setShownForms, handleChange]
    );

    return (
        <DraggableList
            data={data}
            handleDNDFinish={handleReorder}
            renderItem={({item, ...draggableProps}) => (
                <ShownForm
                    key={item.entityId}
                    toggleChecked={toggleChecked}
                    totalSelected={totalSelected}
                    {...item}
                    {...draggableProps}
                />
            )}
        />
    );
};
